import { useState } from 'react';

import { ADMIN_PAGE_SECTION } from '../adminLayout';
import type { PeopleFilter } from '../linkedAccounts';
import { COMMIT_IDENTITY_COPY as WORDS } from '../linkedAccountsCopy';
import { ConsoleHeader } from './ConsoleHeader';
import { CoverageSummary } from './CoverageSummary';
import { NeedsALook } from './NeedsALook';
import { PeopleDirectory } from './PeopleDirectory';
import { RequiredInRail } from './RequiredInRail';
import { SignInCard } from './SignInCard';

/**
 * Admin → Commit identity (specs 160–168): who pushes as themselves, and what
 * stops the rest. The console header answers how many (specs 164, 168); what needs a look
 * comes next, then everyone (spec 162). Beside them, the rail: where a
 * personal account is required and what that costs, and sign-in setup, which
 * opens in a sheet (spec 165). On a narrow screen the rail follows the list.
 */
export function AdminLinkedAccountsPage({
  q,
  show,
  onChange,
}: {
  q: string;
  show: PeopleFilter;
  onChange: (next: { q?: string; show?: PeopleFilter }) => void;
}) {
  // The sign-in sheet: closed, open on the list (null), or at a host's form.
  const [signInHost, setSignInHost] = useState<string | null | undefined>(
    undefined,
  );

  return (
    <section className={ADMIN_PAGE_SECTION}>
      <ConsoleHeader
        title={WORDS.title}
        description={WORDS.description}
        answer={
          <CoverageSummary
            onShow={(next) => onChange({ show: next })}
            onSetUp={() => setSignInHost(null)}
          />
        }
      />
      <div className="grid min-w-0 gap-6 lg:grid-cols-[minmax(0,1fr)_20rem]">
        <div className="flex min-w-0 flex-col gap-6">
          <NeedsALook onSetUp={setSignInHost} />
          <PeopleDirectory q={q} show={show} onChange={onChange} />
        </div>
        <aside className="flex min-w-0 flex-col gap-4 lg:sticky lg:top-6 lg:self-start">
          <RequiredInRail />
          <SignInCard
            openHost={signInHost}
            onOpen={setSignInHost}
            onClose={() => setSignInHost(undefined)}
          />
        </aside>
      </div>
    </section>
  );
}
